var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { column: "", role: "region", "aria-label": "Notes content" } },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/notes-cover.png",
          height: "350",
          role: "img",
          "aria-label": "Notes section banner",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                column: "",
                "pb-2": "",
                role: "region",
                "aria-label": "Notes layout",
              },
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c("search", {
                    attrs: { subject: "notes", limit: _vm.limit },
                    on: { onChangedText: _vm.onSearchChange },
                  }),
                  _vm._v(" "),
                  _c("posts", {
                    attrs: {
                      posts: _vm.posts,
                      title: _vm.$t("components.notes.title"),
                      "is-loading": _vm.isLoading,
                      role: "region",
                      "aria-label": "Notes posts section",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }